<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-10 10:01:45
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-05 19:42:05
-->
<template>
	<div class="downBox">
		<el-select v-model="selectShopId" @change="selectTemplate">
			<el-option v-for="(item, index) in list" :key="index" :label="item.group_name" :value="item.id">
				<span v-if="index !== list.length - 1" style="float: left" class="span-style">{{ item.group_name }}</span>
				<div v-else class="yx-color-success" @click="createShopGroup"><i class="font-blue el-icon-plus"></i> 创建商品组</div>
			</el-option>
		</el-select>
	</div>
</template>
<script>
import { selectList } from '@/api/shopManage';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
	},
	mounted() {
		this.$Bus.$on('clear', () => {
			this.selectShopId = '';
		});
		this.platformId && this.initList();
	},
	name: 'JoinShopGroup',
	data() {
		return {
			selectShopId: '',
			list: [],
		};
	},
	watch: {
		platformId() {
			this.initList();
		},
	},
	methods: {
		async initList() {
			const {
				code,
				data: { list },
			} = await selectList({ platform_id: this.platformId });
			if (code === 0) {
				this.list = list;
				this.list.push({ group_name: '创建商品组', id: '999' });
			}
		},
		selectTemplate() {
			this.$emit('selectShopFun', this.selectShopId);
		},
		createShopGroup() {
			this.$emit('createShopGroup');
		},
	},
	beforeDestroy() {
		this.$Bus.$off('clear');
	},
};
</script>
<style lang="less" scoped>
</style>